export * from './personalization-dialog-proxy.component';
